import { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import withPermissionProtection from 'hoc/withPermissionProtection';

import Grid from '@material-ui/core/Grid';
import Typography from 'components/CncUI/Typography';
import Loader from 'components/Loader';
import Link from './Link';

import useQuery from 'hooks/useQuery';

import Logger from 'utilities/logger';

const useStyles = makeStyles(({ breakpoints, palette }) => ({
  root: {},
  header: {
    marginTop: 32,
    marginBottom: 24,
    color: palette.cncUI.primary.gray['+2'],
    [breakpoints.only('xs')]: {
      textAlign: 'center',
    },
  },
  content: {
    marginTop: 0,
  },
}));

const List = () => {
  const logger = Logger('AppLinks');
  const classes = useStyles();
  const getAppLinks = useQuery('GetApplicationLinks', {
    response: res => res.data.getAppLinks || [],
  });
  const [state, setState] = useState({ appLinks: [], loading: true });
  const modify = data => setState(old => ({ ...old, ...data }));

  useEffect(() => {
    getAppLinks()
      .then(appLinks => modify({ appLinks }))
      .catch(err => logger.error(err))
      .finally(() => modify({ loading: false }));
  }, []);

  const key = name => `AppLink-${name.replace(/ /g, '')}`;

  return (
    <Grid container spacing={0} id="AppLinks">
      <Grid item xs={12}>
        <Typography variant="h4" className={classes.header} id="AppLinksHeader">
          Links
        </Typography>
      </Grid>
      <Grid item xs={12}>
        {state.loading ? (
          <Loader />
        ) : (
          <Grid
            container
            spacing={2}
            direction="column"
            className={classes.content}
          >
            {state.appLinks.map((link, i) => (
              <Grid item key={i} sm={6} md={12} id={key(link.name)}>
                <Link {...link} />
              </Grid>
            ))}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default withPermissionProtection('openid')(List);
